export const sendToGoogleSheet = (paymentData, donationType) => {
  // For local development:
  // fetch("http://localhost:34567/.netlify/functions/logDonation", {

  // For live production:
  fetch("https://canborneo.id/.netlify/functions/logDonation", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ 
      transactionId: paymentData.id,
      name: `${paymentData.payer.name.given_name} ${paymentData.payer.name.surname}`, 
      email: paymentData.payer.email_address, 
      country_code: paymentData.payer.address.country_code || 'not found',
      value: paymentData.purchase_units[0].amount.value,
      donationType: donationType,
      timestamp: paymentData.create_time,
    })
  })
}

export const sendEmailNotification = (paymentData, donationType) => {
  console.log('sending notification email...');
  console.log(paymentData);
  console.log(donationType);

  // fetch("https://localhost:34567/.netlify/functions/donationEmailNotification", {
  fetch("https://canborneo.id/.netlify/functions/donationEmailNotification", {
    method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ 
        transactionId: paymentData.id,
        name: `${paymentData.payer.name.given_name} ${paymentData.payer.name.surname}`, 
        email: paymentData.payer.email_address, 
        country_code: paymentData.payer.address.country_code || 'not found',
        value: paymentData.purchase_units[0].amount.value,
        donationType: donationType,
        timestamp: paymentData.create_time,
      })
    })
}

export const sendThankyouEmail = (paymentData, donationType) => {
  console.log('sending thank you email...');
  console.log(paymentData);
  console.log(donationType);

  // fetch("https://localhost:34567/.netlify/functions/donationEmailNotification", {
  fetch("https://canborneo.id/.netlify/functions/donationThankyouEmail", {
    method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ 
        transactionId: paymentData.id,
        name: `${paymentData.payer.name.given_name} ${paymentData.payer.name.surname}`, 
        email: paymentData.payer.email_address, 
        country_code: paymentData.payer.address.country_code || 'not found',
        value: paymentData.purchase_units[0].amount.value,
        donationType: donationType,
        timestamp: paymentData.create_time,
      })
    })
}